import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../instance";

const initialState = {
  saving: false,
  bulkDetails: [],
  bulPaymentHeader: {},
};


export const save = createAsyncThunk(
  "saveSlice/save/ordinary",
  async (data, { rejectWithValue }) => {
    let saveUrl = data.url;
    delete data.url;
    try {
      const response = await axiosInstance.post(`/${saveUrl}`, data);
      if (!response.data.success) {
        return rejectWithValue(response.data);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteRequest = createAsyncThunk(
  "deleteSlice/delete/ordinary",
  async (data, { rejectWithValue }) => {
    let deleteUrl = data.url;
    delete data.url; 

    try {
      const response = await axiosInstance.delete(`/${deleteUrl}`, {
        data, 
      });

      if (!response.data.success) {
        return rejectWithValue(response.data);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


export const saveFileUpload = createAsyncThunk(
  "saveSlice/save/saveFileUpload",
  async ({ url, formData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (!response.data.success) {
        return rejectWithValue(response.data);
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const saveFileUploadBulk = createAsyncThunk(
  "saveSlice/save/saveFileUploadBulk",
  async ({ url, formData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (!response.data.success) {
        return rejectWithValue(response.data);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const saveExcel = createAsyncThunk(
  "saveSlice/save/saveExcel",
  async ({ url, formData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (!response.data.success) {
        return rejectWithValue(response.data);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const saveFile = createAsyncThunk("saveSlice/saveFile", async (data) => {
  const res = await axiosInstance
    .post(`/api/images/upload`, data, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })
    .then((res) => res.data);
  return res;
});

export const saveSlice = createSlice({
  name: "save",
  initialState,
  reducers: {
    clearSaveObj: () => {
      return { ...initialState };
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(save.pending, (state) => {
        state.saving = true;
      })
      .addCase(save.fulfilled, (state) => {
        state.saving = false;
      })
      .addCase(save.rejected, (state) => {
        state.saving = false;
      })


      .addCase(deleteRequest.pending, (state) => {
        state.saving = true;
      })
      .addCase(deleteRequest.fulfilled, (state) => {
        state.saving = false;
      })
      .addCase(deleteRequest.rejected, (state) => {
        state.saving = false;
      })
      

      .addCase(saveFileUpload.pending, (state) => {
        state.saving = true;
      })
      .addCase(saveFileUpload.fulfilled, (state, action) => {
        state.saving = false;
      })
      .addCase(saveFileUpload.rejected, (state) => {
        state.saving = false;
      })

      .addCase(saveFileUploadBulk.pending, (state) => {
        state.saving = true;
      })
      .addCase(saveFileUploadBulk.fulfilled, (state, action) => {
        state.saving = false;
        state.bulkDetails =
          action.payload?.data?.bulkPay?.paymentDetailStaging;
        state.bulPaymentHeader = action.payload?.data?.bulkPay?.paymentStaging;
      })
      .addCase(saveFileUploadBulk.rejected, (state) => {
        state.saving = false;
        state.bulkDetails = [];
        state.bulPaymentHeader = {};
      })

      .addCase(saveExcel.pending, (state) => {
        state.saving = true;
      })
      .addCase(saveExcel.fulfilled, (state, action) => {
        state.saving = false;
      })
      .addCase(saveExcel.rejected, (state) => {
        state.saving = false;
      })

      .addCase(saveFile.pending, (state) => {
        state.saving = true;
      })
      .addCase(saveFile.fulfilled, (state, action) => {
        state.saving = false;
      })
      .addCase(saveFile.rejected, (state) => {
        state.saving = false;
      });
  },
});

export default saveSlice.reducer;
export const { clearSaveObj } = saveSlice.actions;
